// TODO: must be refactored
// Section for import npm components -----------------------------------------------------------------------------------
import React, { useState, useEffect } from 'react';

// MUI components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
// import { SelectedStationsContext } from '@providers/MansionNavigation/SelectedStationsProvider';
// import { AppConfigContext } from '@providers/AppConfigProvider';
import SelectedLinesProvider, { useUpdateSelectedLines } from '@providers/MansionNavigation/SelectedLinesProvider';
import SelectedStationsProvider from '@providers/MansionNavigation/SelectedStationsProvider';
import StationsSearch from '@components/MansionNavigation/StationsSearch';
import StationsList from '@components/MansionNavigation/StationsList';

// Section for type definition -----------------------------------------------------------------------------------------
type FormSelectedLines = Array<number> | [];
const stateFormSelectedLines: FormSelectedLines = [];

export default function StationsSelector(props: any): React.JSX.Element {
  const { prefecturesData } = props;
  const { selectedPrefecture } = props;
  const { selectedLine } = props;
  const { modePrefSelect } = props;

  // const { isMobile } = useContext(AppConfigContext);

  const arrSelectedLines: [] = selectedLine.map((line: any) => line.id);
  const [formSelectedLines, setFormSelectedLines] = useState(stateFormSelectedLines);

  const setSelectedLines = useUpdateSelectedLines();

  useEffect(() => {
    const fetchLinesData = async (): Promise<void> => {
      setFormSelectedLines(arrSelectedLines);
      // setSelectedLines(arrSelectedLines);
    };
    fetchLinesData().then();
  }, []);

  // Section for render component --------------------------------------------------------------------------------------
  return (
    // Section for render Mobile mode ----------------------------------------------------------------------------------
    <SelectedLinesProvider>
      <SelectedStationsProvider>
        <Box className="md:pb-10">
          <StationsList
            modePrefSelect={modePrefSelect}
            prefecturesData={prefecturesData}
            selectedPrefecture={selectedPrefecture}
            selectedLine={selectedLine}
          />
          <StationsSearch modePrefSelect={modePrefSelect} selectedPrefecture={selectedPrefecture} />
        </Box>
      </SelectedStationsProvider>
    </SelectedLinesProvider>
  );
}
